import { render, staticRenderFns } from "./QuotationProjects.vue?vue&type=template&id=57ecc0c0&"
import script from "./QuotationProjects.vue?vue&type=script&lang=js&"
export * from "./QuotationProjects.vue?vue&type=script&lang=js&"
import style0 from "./QuotationProjects.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports